import MojitoCore from 'mojito/core';

import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import {MainSportsbook} from './main-sportsbook/index.jsx';
import PriceBoostItem from './price-boost-item/index.jsx';
import {VirtualStream} from './virtual-stream/index.jsx';

import './system-settings-storage/index.js';

// TODO remove when Portal will release 25.7 (June 2025)
MojitoCore.Presentation.uiStyle.prefix = function (values) {
    for (let key in values) {
        if (typeof values[key] === 'function') {
            for (let i in values[key]) {
                // Portal extends Function.prototype with two functions: wrap and argumentNames, which leads to "Range Error: Maximum call stack size exceed"
                if (i === 'wrap' || i === 'argumentNames') {
                    values[key][i] = undefined;
                }
            }
        }
    }

    return this.customPrefixer.prefix(values);
};

class MojitoFixesFeature extends AbstractFeature {
    get name() {
        return 'Mojito Fixes';
    }

    updateMojitoConfig(mojitoConfig) {
        const viewImplementations = ensureHierarchy(mojitoConfig, 'services.viewImplementations');

        viewImplementations.MainSportsbook = {
            implementation: MainSportsbook,
        };

        viewImplementations.PriceBoostItem = {
            implementation: PriceBoostItem,
        };

        viewImplementations.VirtualStream = {
            implementation: VirtualStream,
        };

        return super.updateMojitoConfig(mojitoConfig);
    }

    afterMojito() {
        // Mute annoying and useless PromotionUtils warnings
        MojitoCore.logger.configureLogger('PromotionUtils', {level: MojitoCore.logger.NONE});

        return super.afterMojito();
    }
}

new MojitoFixesFeature(allFeatures);
